<div class="page-wrapper relative bg-app-background">
    <div class="h-[200px] flex-none bg-brand-header" aria-hidden="true"></div>
    <mat-card
        class="absolute left-1/2 top-[130px] box-border w-[calc(100%_-_32px)] max-w-[600px] -translate-x-1/2 !p-0"
        appearance="outlined"
    >
        <mat-card-content class="p-8 text-center text-[#333]/[0.675] min-[632px]:p-12">
            <img class="mx-auto mb-5 block w-[125px] max-w-full" src="logo-dark.svg" [alt]="strings.brandName" />
            <div class="mb-[30px] text-xl font-normal text-brand-primary">
                {{ strings.appLongName }}
            </div>
            <div class="mx-auto max-w-[350px]">
                <h1 class="mx-0 mt-0 mb-5 text-lg font-normal">{{ signoutMessage }}</h1>
                <button class="w-full" mat-flat-button color="primary" (click)="login()">Log in</button>
            </div>
        </mat-card-content>
    </mat-card>
</div>
